import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import { Site, InfoSite } from 'solar-bo';;
import { SolarService } from '../../services/solarservice.service';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { GlobalService } from '@solar/services/global.service';
import { ObjHelper } from 'shtools';
import { MessagebarComponent } from 'basecomponents';



@Component({
  selector: 'app-site-detailedinfo',
  templateUrl: './site-detaildedinfo.component.html',
  styleUrls: ['./site-detaildedinfo.component.scss']
})
export class SiteDetailedComponent extends SolarBase1Component implements OnInit, OnChanges {

  @Output() saveEvent = new EventEmitter<Site>();
  @Input() site: Site = new Site();
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;

  data: any;
  public ckeditor = ClassicEditor;
  public ckconfig={ toolbar: [ 'heading','|','undo', 'redo', '|','bold', 'italic','bulletedList', 'numberedList', 'blockQuote', '|' , 'outdent', 'indent', '|','link','insertTable'] };

  public constructor(
    public globService: GlobalService
    , public solarService: SolarService
  ) {
    super();
  }

  ngOnInit() {
    this.loading = false;
    //this.configEditor();
  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['site'];
    if (typeChange && typeChange.currentValue != undefined) {
      this.site = typeChange.currentValue;

      let st = this.site.info.detailedinfo;
      if (st) {

        st=ObjHelper.cloneDeep("" + this.site.info.detailedinfo);
        this.data = st;
      }else{
        this.data="";
      }

    }
  }

  configEditor() {
    this.ckeditor
      .create(document.querySelector('#editor'), {
        removePlugins: ['Heading', 'Link'],
        toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote']
      })
      .catch(error => {
        console.log(error);
      });
  }

  isvalid() {
    if (this.myform) {
      return this.myform.valid && !this.submitted;
    }
    else {
      return false;
    }

  }

  private prepareSave(): any {
    //const formModel = this.myform.value;
    const cloneModel: Site = new Site();
    cloneModel.id = this.site.id;
    cloneModel.info.detailedinfo = this.data;
    console.log(cloneModel.info.detailedinfo);
    return cloneModel;
  }


  saveModel(value?: any) {
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

      const clonemodel = this.prepareSave();
      this.solarService.siteEditCreate(clonemodel)
        .subscribe((res) => this.savehandleresult(res), err => this.savehandleError(err)
        );
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  savehandleresult(resultmodel: Site) {
    console.log("site saved", resultmodel);
    this.submitted = false;
    this.loading = false;
    this.showmessage('Site detailed info saved ');
    this.site.info.detailedinfo = resultmodel.info.detailedinfo;
    this.saveEvent.emit(this.site);
  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.showerror("Error saving site. Message: " + err.message);
  }

}
